const getElementAttributes = (element) => {
  if (!element?.hasAttributes()) {
    return {};
  }

  return [...element.attributes].reduce(
    (acc, attr) => ({
      ...acc,
      [attr.name]: attr.value,
    }),
    {}
  );
};

export default getElementAttributes;
